import styled from 'styled-components'
import { rem } from 'polished'
import clsx from 'clsx'

import BodyTextBlock from 'LuxKit/TextBlocks/BodyTextBlock'
import { mediaQueryUp } from 'components/utils/breakpoint'

const List = styled.ul`
  margin: 0;
  padding: 0;
  list-style: none;

  > li {
    break-inside: avoid;
  }

  &.columns-on-tablet {
    ${mediaQueryUp.tablet} {
      columns: 2;
    }
  }
`

const BulletSlot = styled.span`
  display: flex;
  width: ${rem(24)};
  height: 100%;
  align-items: center;
  justify-content: center;
`

const Bullet = styled.span`
  display: block;
  width: ${rem(4)};
  height: ${rem(4)};
  border-radius: 50%;
  background: currentColor;
`

const getItemKey = (item: string, index: number) => `${item}-${index}`

type Props = {
  items: Array<string>
  columnsOnTablet?: boolean
  className?: string
  getKey?: (item: string, index: number) => string
}

function AccommodationTextList({ items, columnsOnTablet, className, getKey = getItemKey }: Props) {
  return (
    <List className={clsx(className, { 'columns-on-tablet': columnsOnTablet })}>
      {items.map((item, index) => (
        <li key={getKey(item, index)}>
          <BodyTextBlock
            variant="medium"
            startIcon={<BulletSlot aria-hidden="true"><Bullet /></BulletSlot>}
          >
            {item}
          </BodyTextBlock>
        </li>
      ))}
    </List>
  )
}

export default AccommodationTextList
